import { User, AdminStatus } from 'state/user/UserTypes';
import { AppState } from 'state/store';

export const selectAdminStatus = (state: AppState): AdminStatus | undefined => {
   return state.currentUser.user?.adminStatus
};

export const selectIsAuthenticated = (state: AppState): boolean => {
   return state.currentUser.isAuthenticated;
};

export const selectCurrentUser = (state: AppState): User | null => {
   return state.currentUser.user;
};

export const selectIsUserLoggedIn = (state: AppState): boolean => {
   return !!state.currentUser.user;
};

export const selectProfileError = (state: AppState): boolean => {
   return state.currentUser.profileError;
};
